// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ig-1";
export var messageSideRight = "_ig-2";
export var subscribeToBackInStockBubbleContainer = "_ig-0";